import { render, staticRenderFns } from "./IconeAjudaIncidencia.vue?vue&type=template&id=1c938a5c&"
import script from "./IconeAjudaIncidencia.vue?vue&type=script&lang=js&"
export * from "./IconeAjudaIncidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports